import { path } from 'ramda';

export const checkAttachments = (state, kind) => {
  const key = `${kind}_id`;
  if (path(['response', 'id'], state[kind][0])) {
    return { [key]: state[kind][0].response.id };
  }

  if (state[key]) {
    return { [key]: state[key] };
  }
  return {};
};
